<template>
  <!-- C-8 (XOL-596 UX): after the server answered 428 version_required and the user
       chose "Not now", the page can't save text and field changes until it is
       reloaded. Rendered only then; `versionRequiredSeen` is a Vue.observable. -->
  <el-alert
    v-if="outOfDate"
    class="out-of-date-banner"
    type="error"
    show-icon
    :closable="false"
    :title="banner">
    <el-button size="mini" type="primary" @click="reload">{{reloadLabel}}</el-button>
  </el-alert>
</template>

<script>
import { syncState } from '@/lib/requestRowSync'
import { copyText } from '@/lib/requestSyncCopy'

export default {
  name: 'out-of-date-banner',

  data () {
    return {
      banner: copyText('requestSync.reload.banner'),
      reloadLabel: copyText('requestSync.reload.confirm')
    }
  },

  computed: {
    outOfDate () {
      return !!syncState.versionRequiredSeen
    }
  },

  methods: {
    reload () {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.out-of-date-banner { margin-bottom: 0.5em; }
</style>
